import { useEffect, useMemo } from '@integrations/react'
import { useMyAccountAccessQry } from 'mmfintech-backend-api'
import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'

const EMPTY_ACCOUNTS: AccountBalanceResponse[] = []

/**
 * Narrows a flow's accounts to those the user may move money with (owners and administrators keep all of them) and
 * replaces a selection that falls outside that list, so a view-only account is never offered or preselected.
 */
export function useWritableAccounts(
  accounts: AccountBalanceResponse[] | undefined,
  selectedAccount?: AccountBalanceResponse | null,
  setSelectedAccount?: (account: AccountBalanceResponse | null) => void
) {
  const { hasWritePermission } = useMyAccountAccessQry()

  const writableAccounts = useMemo(
    () => (accounts ?? EMPTY_ACCOUNTS).filter((account) => hasWritePermission(account.id)),
    [accounts, hasWritePermission]
  )

  useEffect(() => {
    if (selectedAccount?.id && setSelectedAccount && !writableAccounts.some((a) => a.id === selectedAccount.id)) {
      setSelectedAccount(writableAccounts[0] ?? null)
    }
  }, [selectedAccount, setSelectedAccount, writableAccounts])

  return writableAccounts
}
